var React = require('react');

function ChartArea (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.25 25c.412 0 .75.338.75.75v1.5c0 .412-.338.75-.75.75H.75a.753.753 0 0 1-.75-.75V4.75C0 4.338.338 4 .75 4h1.5c.412 0 .75.338.75.75V25h28.25zm-8-16.956a.749.749 0 0 1 1.106.325L30 22H6v-6l5.506-9.631a.752.752 0 0 1 1.175-.144L18 11.544zM9 16.831V19h16.45l-2.788-6.956c-4.531 3.025-.556.369-5.044 3.363l-5.025-5.025z"}));
}

ChartArea.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = ChartArea;

ChartArea.default = ChartArea;
